export default {
  responseType: 'json'
}



// WEBPACK FOOTER //
// ./src/config/kansas.js